import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";

import { CanActivateViaOAuthGuard } from '../oAuth.canActivateGuard';

import { NofeshAdminHomeComponent } from "./admin/home/home.component";
import { AddNofeshComponent } from "./admin/add-nofesh/add-nofesh.component";
import { NofashimComponent } from "./admin/nofashim/nofashim.component"
import { HomeComponent } from './home/home.component';
import { NofeshDetailsComponent } from "./nofesh-details/nofesh-details.component";
import { OrderNofeshComponent } from "./order/order-nofesh.component";
import { NofeshPaymentComponent } from "./order/nofesh-payment.component";
import { NofeshUploadsComponent } from "./nofesh-uploads/nofesh-uploads.component";
import { EndRishumComponent } from "./nofesh-end-rishum/end-rishum.component";

@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'nofesh-admin', component: NofeshAdminHomeComponent, canActivate: [CanActivateViaOAuthGuard], children: [

                { path: '', redirectTo: 'nofashim', pathMatch: 'full' },
                { path: 'add-nofesh/:id', component: AddNofeshComponent },
                { path: 'add-nofesh', component: AddNofeshComponent },
                { path: 'nofashim', component: NofashimComponent }

            ]
        },
        {
            path: 'nofesh', component: NofeshAdminHomeComponent, canActivate: [CanActivateViaOAuthGuard], children: [
                { path: 'home', component: HomeComponent },
                { path: 'nofesh-details/:id', component: NofeshDetailsComponent },
                { path: 'order-nofesh/:id', component: OrderNofeshComponent },
                
                { path: 'nofesh-uploads', component: NofeshUploadsComponent },
                { path: 'nofesh-payment', component: NofeshPaymentComponent },
                { path: 'end-rishum', component: EndRishumComponent },
                { path: '', redirectTo: 'home', pathMatch: 'full' }



            ]
        }

    ])],
    exports: [RouterModule]
})

export class NofeshRouting {

}